import ScanFile from "./scan_file";
export default ScanFile;
